import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import "./Formulaire.scss";

const Formulaire = () => {
  const form = useRef();
  const [buttonText, setButtonText] = useState("Demander mon devis !");
  const [isDisabled, setIsDisabled] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const nom = document.querySelector("#input-nom");
    const prenom = document.querySelector("#input-prenom");
    const mail = document.querySelector("#input-email");
    const telephone = document.querySelector("#input-telephone");
    const budget = document.querySelector("#input-budget");
    const piscine = document.querySelector("#input-piscine");
    const message = document.querySelector("#input-message");
    const ville = document.querySelector("#input-ville");

    const inputFields = {
      nom: nom.value,
      prenom: prenom.value,
      mail: mail.value,
      telephone: telephone.value,
      budget: budget.value,
      piscine: piscine.value,
      message: message.value,
      ville: ville.value,
    };

    console.log(inputFields);

    setButtonText("Envoi en cours...");
    setIsDisabled(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        inputFields,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        () => {
          console.log("Email sent : DONE");
          setButtonText("Devis envoyé");
        },
        (error) => {
          console.log(error);
          setButtonText("Erreur lors de l'envoi");
        }
      );

    setTimeout(() => {
      nom.value = "";
      prenom.value = "";
      mail.value = "";
      telephone.value = "";
      budget.value = "";
      piscine.value = "";
      message.value = "";
      ville.value = "";
      setButtonText("Demander mon devis !");
      setIsDisabled(false);
    }, 3000);
  };

  return (
    <div className="form-container">
      <div
        className="form"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="400"
      >
        <h2>Demandez un devis !</h2>
        <p>
          Plongez pour demander un devis détaillé pour des besoins sur mesures.
        </p>
        <form ref={form} onSubmit={sendEmail} className="quote-form">
          <div className="form-row">
            <select
              name="typePiscine"
              className="input-field"
              id="input-piscine"
              required
            >
              <option value="" disabled>
                Type de piscine
              </option>
              <option value="beton">Piscine en béton</option>
              <option value="coque">Piscine à coque</option>
              <option value="carrelage">piscine carrelée</option>
              <option value="debordement">Piscine à débordement</option>
            </select>
            <input
              type="text"
              name="nom"
              placeholder="Nom"
              className="input-field"
              id="input-nom"
              required
            />
            <input
              type="text"
              name="prenom"
              placeholder="Prénom"
              id="input-prenom"
              className="input-field"
              required
            />
          </div>
          <div className="form-row">
            <select
              name="budget"
              className="input-field"
              id="input-budget"
              required
            >
              <option value="" disabled>
                Budget
              </option>
              <option value="moins de 20k €">Moins de 20,000€</option>
              <option value="entre 20k-50k €">Entre 20,000€ et 50,000€</option>
              <option value="plus de 50k €">Plus de 50,000€</option>
            </select>
            <input
              type="email"
              name="email"
              id="input-email"
              placeholder="Adresse Email"
              className="input-field"
              required
            />

            <input
              type="tel"
              name="telephone"
              id="input-telephone"
              placeholder="Numéro de téléphone"
              className="input-field"
              required
            />
          </div>
          <div className="form-row">
            <input
              type="text"
              name="ville"
              id="input-ville"
              placeholder="Adresse / Ville"
              className="input-field"
              required
            />
          </div>
          <textarea
            id="input-message"
            name="message"
            placeholder="Décrivez-nous votre projet"
            className="input-field message"
            required
          ></textarea>
          <button
            aria-label="bouton vers demander un devis"
            type="submit"
            className="submit-button"
            id="bouton-devis"
            disabled={isDisabled}
          >
            {buttonText}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Formulaire;
